/*
 * Klaviyo popup trigger - Memento corporate site.
 *
 * Two ways to open a Klaviyo form from any element, no code required:
 *   1. F1A parity: class="kl_form_trigger" data-klaviyo-form-id="AbC123"
 *   2. Theme editor convention: point any button/link at "#klaviyo:AbC123"
 *      (works in every Impact button block - staff paste it as the link).
 *
 * Uses the same _klOnsite openForm call as the F1A theme's footer helper.
 */
(function () {
  function openForm(formId) {
    if (!formId) return;
    if (window._klOnsite && typeof window._klOnsite.push === 'function') {
      window._klOnsite.push(['openForm', formId]);
    }
  }

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest &&
             event.target.closest('.kl_form_trigger, a[href^="#klaviyo:"]');
    if (!el) return;

    var formId = '';
    if (el.hasAttribute('data-klaviyo-form-id')) {
      formId = (el.getAttribute('data-klaviyo-form-id') || '').trim();
    } else {
      var href = el.getAttribute('href') || '';
      formId = href.replace('#klaviyo:', '').trim();
    }
    if (!formId) return;

    event.preventDefault();
    openForm(formId);
  });

  // hash auto-open: visiting any page with #klaviyo:FORMID opens that form.
  // Gives the site shareable enquiry links (and lets campaigns deep-link a popup).
  function hashOpen() {
    var h = (location.hash || '');
    if (h.indexOf('#klaviyo:') !== 0) return;
    var id = h.slice(9).trim();
    if (!id) return;
    var tries = 0;
    var t = setInterval(function () {
      if (window._klOnsite && typeof window._klOnsite.push === 'function') {
        clearInterval(t); openForm(id);
      } else if (++tries > 40) { clearInterval(t); }
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hashOpen);
  else hashOpen();
  window.addEventListener('hashchange', hashOpen);

})();
